import { SplashContainer, SplashSubtitle, SplashTitle } from './splash.styles'

export const Splash = () => {
  return (
    <SplashContainer>
      <div>
        <SplashTitle>Pocket Network Node Rewards For Everyone</SplashTitle>
        <SplashSubtitle>Seamlessly invest in POKT Shares</SplashSubtitle>
      </div>
    </SplashContainer>
  )
}
